export enum PartnerSectionEnum {
  readyForPayments = 'ready-for-payments',
  pending = 'pending',
}
